var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4 2.89543 4.89543 2 6 2H15L20 7V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z",
    fill: "#E7E9EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2L20 7H15V2Z",
    fill: "#CFD3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSkeleton);
export default __webpack_public_path__ + "static/media/file-skeleton.cfec4cf8a2425a539c75aacfac6c09a3.svg";
export { ForwardRef as ReactComponent };